import React from 'react';
import {SwipeableDrawer} from "@mui/material";
import uiStore from "../../lib/stores/uiStore";
import UserInfo from "./UserInfo";
import {observer} from "mobx-react";

const MobileUserInfo = () => {

    return <SwipeableDrawer
            anchor={"bottom"}
            open={uiStore.userInfoVisible}
            onOpen={() => {

            }}
            onClose={() => uiStore.userInfoVisible = false}
            PaperProps={{
                sx: {
                    width: "100%",
                    overflow: "initial"
                },
            }}
    >
        {uiStore.userInfoView?.selectedUser && <UserInfo user={uiStore.userInfoView.selectedUser}/>}
    </SwipeableDrawer>
};

export default observer(MobileUserInfo);
